(function () {
  'use strict';

  var announcement = document.querySelector('[data-tasi-announcement]');
  if (announcement) {
    document.body.classList.add('has-announcement');
  }

  var header = document.querySelector('[data-tasi-header]');
  if (header) {
    var isForceSolid = header.dataset.headerForceSolid === 'true';
    var isTransparent = !isForceSolid && header.dataset.headerMode === 'transparent';
    var onScroll = function () {
      if (!isTransparent) return;
      header.classList.toggle('is-scrolled', window.scrollY > 50);
    };
    onScroll();
    if (!isForceSolid) {
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
    }
  }

  var toggle = document.querySelector('[data-tasi-mobile-toggle]');
  var menu = document.querySelector('[data-tasi-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      menu.classList.toggle('is-open');
      document.body.classList.toggle('menu-open');
    });
  }

  var searchToggle = document.querySelector('[data-tasi-search-toggle]');
  var searchPanel = document.querySelector('[data-tasi-search]');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      searchPanel.classList.toggle('is-open');
      var input = searchPanel.querySelector('input');
      if (input && searchPanel.classList.contains('is-open')) input.focus();
    });
  }

  document.querySelectorAll('[data-tasi-currency]').forEach(function (currencyRoot) {
    var toggle = currencyRoot.querySelector('[data-tasi-currency-toggle]');
    var menu = currencyRoot.querySelector('[data-tasi-currency-menu]');
    var input = currencyRoot.querySelector('[data-tasi-currency-input]');
    var label = currencyRoot.querySelector('[data-tasi-currency-label]');
    var form = currencyRoot.querySelector('.tasi-currency__form');
    if (!toggle || !menu || !input || !form) return;

    function closeMenu() {
      currencyRoot.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      menu.hidden = true;
    }

    toggle.addEventListener('click', function (event) {
      event.stopPropagation();
      var willOpen = menu.hidden;
      closeMenu();
      if (willOpen) {
        currencyRoot.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        menu.hidden = false;
      }
    });

    menu.querySelectorAll('[data-tasi-currency-option]').forEach(function (optionButton) {
      optionButton.addEventListener('click', function () {
        var nextCurrency = optionButton.getAttribute('data-tasi-currency-option');
        if (!nextCurrency || nextCurrency === input.value) {
          closeMenu();
          return;
        }

        input.value = nextCurrency;
        if (label) label.textContent = nextCurrency;
        menu.querySelectorAll('.tasi-currency__option').forEach(function (item) {
          var isActive = item.querySelector('[data-tasi-currency-option]').getAttribute('data-tasi-currency-option') === nextCurrency;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        closeMenu();
        form.submit();
      });
    });

    document.addEventListener('click', function (event) {
      if (!currencyRoot.contains(event.target)) closeMenu();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeMenu();
    });
  });

  var featureSplit = document.querySelector('.tasi-feature-split');
  if (featureSplit && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    observer.observe(featureSplit);
  }

  var newsletterForm = document.querySelector('[data-tasi-newsletter]');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var success = newsletterForm.querySelector('[data-tasi-newsletter-success]');
      if (success) success.hidden = false;
    });
  }

  document.querySelectorAll('[data-tasi-mobile-back]').forEach(function (button) {
    button.addEventListener('click', function () {
      if (window.history.length > 1) {
        window.history.back();
      } else {
        window.location.href = '/';
      }
    });
  });

  function initProductCarousels(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-tasi-product-carousel]').forEach(function (carousel) {
      if (carousel.dataset.carouselReady === 'true') return;

      var viewport = carousel.querySelector('[data-carousel-viewport]');
      var track = carousel.querySelector('[data-carousel-track]');
      var progressThumb = carousel.querySelector('[data-carousel-progress]');
      if (!viewport || !track) return;

      carousel.dataset.carouselReady = 'true';

      var dragState = {
        active: false,
        startX: 0,
        startY: 0,
        startScroll: 0,
        moved: false,
        pointerId: null
      };

      var DRAG_THRESHOLD = 10;

      function isFitLayout() {
        if (!carousel.classList.contains('tasi-influencer-looks')) return false;
        return carousel.classList.contains('tasi-influencer-looks--grid') && window.innerWidth > 980;
      }

      function getSlidesPerView() {
        if (carousel.classList.contains('tasi-influencer-looks') && window.innerWidth > 980) {
          return 5;
        }
        if (window.innerWidth <= 767) {
          return parseInt(carousel.dataset.slidesMobile, 10) || 1;
        }
        if (window.innerWidth <= 980) {
          return parseInt(carousel.dataset.slidesTablet, 10) || 2;
        }
        return parseInt(carousel.dataset.slidesDesktop, 10) || 5;
      }

      function getGap() {
        var styles = window.getComputedStyle(track);
        return parseFloat(styles.columnGap || styles.gap || '0') || 0;
      }

      function updateProgress() {
        if (!progressThumb) return;
        var maxScroll = Math.max(viewport.scrollWidth - viewport.clientWidth, 0);
        var thumbWidth = viewport.scrollWidth > 0
          ? (viewport.clientWidth / viewport.scrollWidth) * 100
          : 100;
        var left = maxScroll > 0
          ? (viewport.scrollLeft / maxScroll) * (100 - thumbWidth)
          : 0;
        progressThumb.style.width = thumbWidth + '%';
        progressThumb.style.left = left + '%';
      }

      function updateMetrics() {
        var slides = getSlidesPerView();
        var gap = getGap();

        carousel.style.setProperty('--carousel-slides', slides);

        if (isFitLayout()) {
          viewport.scrollLeft = 0;
          updateProgress();
          return;
        }

        var slideWidth = (viewport.clientWidth - gap * (slides - 1)) / slides;
        carousel.style.setProperty('--carousel-slide-width', Math.max(slideWidth, 0) + 'px');
        updateProgress();
      }

      function onPointerDown(event) {
        if (isFitLayout()) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        dragState.active = true;
        dragState.startX = event.clientX;
        dragState.startY = event.clientY;
        dragState.startScroll = viewport.scrollLeft;
        dragState.moved = false;
        dragState.pointerId = event.pointerId;
      }

      function onPointerMove(event) {
        if (!dragState.active) return;
        var deltaX = event.clientX - dragState.startX;
        var deltaY = event.clientY - dragState.startY;

        if (!dragState.moved) {
          if (Math.abs(deltaX) < DRAG_THRESHOLD && Math.abs(deltaY) < DRAG_THRESHOLD) return;
          dragState.moved = true;
          viewport.classList.add('is-dragging');
          if (viewport.setPointerCapture) {
            viewport.setPointerCapture(dragState.pointerId);
          }
        }

        event.preventDefault();
        viewport.scrollLeft = dragState.startScroll - deltaX;
        updateProgress();
      }

      function blockNextClick() {
        var blockClick = function (clickEvent) {
          clickEvent.preventDefault();
          clickEvent.stopImmediatePropagation();
        };
        track.querySelectorAll('a').forEach(function (link) {
          link.addEventListener('click', blockClick, { capture: true, once: true });
        });
      }

      function onPointerEnd(event) {
        if (!dragState.active) return;
        var didDrag = dragState.moved;
        dragState.active = false;
        dragState.moved = false;
        dragState.pointerId = null;
        viewport.classList.remove('is-dragging');
        if (viewport.releasePointerCapture && event.pointerId != null) {
          try { viewport.releasePointerCapture(event.pointerId); } catch (e) {}
        }
        if (didDrag) blockNextClick();
        updateProgress();
      }

      viewport.addEventListener('pointerdown', onPointerDown);
      viewport.addEventListener('pointermove', onPointerMove, { passive: false });
      viewport.addEventListener('pointerup', onPointerEnd);
      viewport.addEventListener('pointercancel', onPointerEnd);
      viewport.addEventListener('scroll', updateProgress, { passive: true });

      track.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('dragstart', function (event) {
          event.preventDefault();
        });
      });

      window.addEventListener('resize', updateMetrics, { passive: true });
      updateMetrics();
      window.requestAnimationFrame(updateMetrics);
    });
  }

  initProductCarousels();

  function parseShopifyJson(text) {
    if (!text) return null;
    var normalized = text.replace(/"(id|variant_id|product_id|image_id|media_id)":(\d{15,})/g, '"$1":"$2"');
    return JSON.parse(normalized);
  }

  function addItemToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: String(variantId),
        quantity: quantity || 1
      })
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) {
          throw new Error(data.description || data.message || 'Add failed');
        }
        return data;
      });
    });
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = (Number(cents) / 100).toFixed(2);
    if (!format) return value;
    return format.replace(/\{\{\s*amount\s*\}\}/, value).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(Number(cents) / 100).toString());
  }

  function initCartDrawer() {
    var drawer = document.querySelector('[data-tasi-cart-drawer]');
    if (!drawer || drawer.dataset.cartReady === 'true') return;
    drawer.dataset.cartReady = 'true';

    var moneyFormat = drawer.dataset.moneyFormat || '${{amount}}';
    var currencyCode = drawer.dataset.currency || 'USD';
    var itemsEl = drawer.querySelector('[data-tasi-cart-items]');
    var emptyEl = drawer.querySelector('[data-tasi-cart-empty]');
    var footerEl = drawer.querySelector('[data-tasi-cart-footer]');
    var subtotalEl = drawer.querySelector('[data-tasi-cart-subtotal]');
    var promoEl = drawer.querySelector('[data-tasi-cart-promo]');
    var checkoutEl = drawer.querySelector('[data-tasi-cart-checkout]');
    var countEls = document.querySelectorAll('[data-tasi-cart-count]');
    var productCache = {};
    var isOpen = false;

    function formatCartMoney(cents) {
      var raw = formatMoney(cents, moneyFormat);
      var numeric = raw.replace(/[^\d.,]/g, '').replace(/,/g, '');
      if (numeric.endsWith('.00')) numeric = numeric.slice(0, -3);
      return numeric + ' ' + currencyCode;
    }

    function updateHeaderCount(count) {
      countEls.forEach(function (el) {
        if (count > 0) {
          el.textContent = count;
          el.hidden = false;
        } else {
          el.textContent = '0';
          el.hidden = true;
        }
      });
    }

    function getProduct(handle) {
      if (productCache[handle]) return Promise.resolve(productCache[handle]);
      return fetch('/products/' + handle + '.js')
        .then(function (response) { return response.json(); })
        .then(function (product) {
          productCache[handle] = product;
          return product;
        });
    }

    function escapeHtml(text) {
      var div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    function getSizeOption(item) {
      if (!item.options_with_values || !item.options_with_values.length) {
        return item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : null;
      }
      var sizeOption = item.options_with_values.find(function (opt) {
        return /size/i.test(opt.name);
      });
      return sizeOption ? sizeOption.value : item.variant_title;
    }

    function buildSizeSelect(item, product) {
      var currentSize = getSizeOption(item);
      if (!product || !product.variants || product.variants.length <= 1) {
        if (!currentSize) return '';
        return '<span class="tasi-cart-drawer__size-label">' + escapeHtml(currentSize) + '</span>';
      }

      var sizeOptionIndex = -1;
      if (product.options) {
        product.options.forEach(function (name, index) {
          if (/size/i.test(name)) sizeOptionIndex = index;
        });
      }

      if (sizeOptionIndex === -1) {
        if (!currentSize) return '';
        return '<span class="tasi-cart-drawer__size-label">' + escapeHtml(currentSize) + '</span>';
      }

      var sizes = {};
      product.variants.forEach(function (variant) {
        var sizeValue = variant['option' + (sizeOptionIndex + 1)];
        if (sizeValue) sizes[sizeValue] = variant;
      });

      var options = Object.keys(sizes).map(function (size) {
        var variant = sizes[size];
        var selected = String(variant.id) === String(item.variant_id) ? ' selected' : '';
        var disabled = variant.available ? '' : ' disabled';
        return '<option value="' + variant.id + '"' + selected + disabled + '>' + escapeHtml(size) + '</option>';
      }).join('');

      return '<select class="tasi-cart-drawer__size" data-cart-size data-line-key="' + escapeHtml(item.key) + '" aria-label="Size">' + options + '</select>';
    }

    function renderItem(item, product) {
      var image = item.image || (item.featured_image && item.featured_image.url) || '';
      var sizeControl = buildSizeSelect(item, product);

      return (
        '<article class="tasi-cart-drawer__item" data-cart-line="' + escapeHtml(item.key) + '">' +
          '<a href="' + escapeHtml(item.url) + '" class="tasi-cart-drawer__item-image">' +
            (image ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy" width="84" height="126">' : '') +
          '</a>' +
          '<div class="tasi-cart-drawer__item-details">' +
            '<div class="tasi-cart-drawer__item-head">' +
              '<div class="tasi-cart-drawer__item-meta">' +
                '<a href="' + escapeHtml(item.url) + '" class="tasi-cart-drawer__item-title">' + escapeHtml(item.product_title) + '</a>' +
                '<p class="tasi-cart-drawer__item-price">' + formatCartMoney(item.final_price) + '</p>' +
              '</div>' +
              '<button type="button" class="tasi-cart-drawer__remove" data-cart-remove data-line-key="' + escapeHtml(item.key) + '">Remove</button>' +
            '</div>' +
            '<div class="tasi-cart-drawer__item-controls">' +
              '<div class="tasi-cart-drawer__qty">' +
                '<button type="button" class="tasi-cart-drawer__qty-btn" data-cart-qty="-1" data-line-key="' + escapeHtml(item.key) + '" aria-label="Decrease quantity"' + (item.quantity <= 1 ? ' disabled' : '') + '>&minus;</button>' +
                '<span class="tasi-cart-drawer__qty-value" data-cart-qty-value>' + item.quantity + '</span>' +
                '<button type="button" class="tasi-cart-drawer__qty-btn" data-cart-qty="1" data-line-key="' + escapeHtml(item.key) + '" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<div class="tasi-cart-drawer__size-wrap">' + sizeControl + '</div>' +
            '</div>' +
          '</div>' +
        '</article>'
      );
    }

    function renderCart(cart) {
      updateHeaderCount(cart.item_count);

      if (!cart.item_count) {
        if (itemsEl) itemsEl.innerHTML = '';
        if (emptyEl) emptyEl.hidden = false;
        if (footerEl) footerEl.hidden = true;
        if (promoEl) promoEl.hidden = true;
        return;
      }

      if (emptyEl) emptyEl.hidden = true;
      if (footerEl) footerEl.hidden = false;
      if (promoEl) promoEl.hidden = cart.item_count === 0;
      if (subtotalEl) subtotalEl.textContent = formatCartMoney(cart.total_price);
      if (checkoutEl) checkoutEl.href = '/checkout';

      var uniqueHandles = [];
      cart.items.forEach(function (item) {
        if (item.handle && uniqueHandles.indexOf(item.handle) === -1) uniqueHandles.push(item.handle);
      });

      Promise.all(uniqueHandles.map(getProduct))
        .then(function (products) {
          var productMap = {};
          products.forEach(function (product) {
            productMap[product.handle] = product;
          });
          if (itemsEl) {
            itemsEl.innerHTML = cart.items.map(function (item) {
              return renderItem(item, productMap[item.handle]);
            }).join('');
          }
        })
        .catch(function () {
          if (itemsEl) {
            itemsEl.innerHTML = cart.items.map(function (item) {
              return renderItem(item, null);
            }).join('');
          }
        });
    }

    function fetchCart() {
      return fetch('/cart.js')
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          renderCart(cart);
          return cart;
        });
    }

    function changeLine(key, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          renderCart(cart);
          return cart;
        });
    }

    function swapVariant(lineKey, newVariantId, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: newVariantId, quantity: quantity })
          });
        })
        .then(function () { return fetchCart(); });
    }

    function openDrawer() {
      if (isOpen) return;
      isOpen = true;
      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-drawer-open');
      window.requestAnimationFrame(function () {
        drawer.classList.add('is-open');
      });
      fetchCart();
    }

    function closeDrawer() {
      if (!isOpen) return;
      isOpen = false;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-drawer-open');
      window.setTimeout(function () {
        if (!isOpen) drawer.hidden = true;
      }, 350);
    }

    document.querySelectorAll('[data-tasi-cart-toggle]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        openDrawer();
      });
    });

    drawer.querySelectorAll('[data-tasi-cart-close]').forEach(function (button) {
      button.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isOpen) closeDrawer();
    });

    drawer.addEventListener('click', function (event) {
      var removeBtn = event.target.closest('[data-cart-remove]');
      if (removeBtn) {
        var removeKey = removeBtn.dataset.lineKey;
        removeBtn.disabled = true;
        changeLine(removeKey, 0).catch(function () {
          removeBtn.disabled = false;
        });
        return;
      }

      var qtyBtn = event.target.closest('[data-cart-qty]');
      if (qtyBtn) {
        var key = qtyBtn.dataset.lineKey;
        var delta = parseInt(qtyBtn.dataset.cartQty, 10);
        var qtyValue = qtyBtn.closest('.tasi-cart-drawer__qty').querySelector('[data-cart-qty-value]');
        var currentQty = parseInt(qtyValue.textContent, 10) || 1;
        var nextQty = Math.max(0, currentQty + delta);
        qtyBtn.disabled = true;
        changeLine(key, nextQty).catch(function () {
          qtyBtn.disabled = false;
        });
        return;
      }
    });

    drawer.addEventListener('change', function (event) {
      var sizeSelect = event.target.closest('[data-cart-size]');
      if (!sizeSelect || sizeSelect.tagName !== 'SELECT') return;

      var lineKey = sizeSelect.dataset.lineKey;
      var newVariantId = sizeSelect.value;
      var lineItem = sizeSelect.closest('[data-cart-line]');
      var qtyEl = lineItem ? lineItem.querySelector('[data-cart-qty-value]') : null;
      var qty = qtyEl ? parseInt(qtyEl.textContent, 10) || 1 : 1;
      sizeSelect.disabled = true;
      swapVariant(lineKey, newVariantId, qty).catch(function () {
        sizeSelect.disabled = false;
      });
    });

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-pdp-form]');
      if (!form) return;
      event.preventDefault();

      var submitBtn = form.querySelector('[data-pdp-submit]');
      if (submitBtn) submitBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form)
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw new Error(data.description || data.message || 'Add failed');
            return data;
          });
        })
        .then(function () {
          if (window.TasiCart) {
            window.TasiCart.refresh().then(openDrawer);
          } else {
            openDrawer();
          }
        })
        .catch(function () {
          form.submit();
        })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    });

    window.TasiCart = {
      open: openDrawer,
      close: closeDrawer,
      refresh: fetchCart
    };
  }

  initCartDrawer();

  var WISHLIST_KEY = 'tasiWishlist';

  function readWishlist() {
    try {
      var stored = window.localStorage.getItem(WISHLIST_KEY);
      var parsed = stored ? JSON.parse(stored) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function writeWishlist(items) {
    window.localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('tasi:wishlist-updated', { detail: { count: items.length } }));
  }

  function initWishlist() {
    var drawer = document.querySelector('[data-tasi-wishlist-drawer]');
    if (!drawer || drawer.dataset.wishlistReady === 'true') return;
    drawer.dataset.wishlistReady = 'true';

    var moneyFormat = drawer.dataset.moneyFormat || '${{amount}}';
    var itemsEl = drawer.querySelector('[data-tasi-wishlist-items]');
    var emptyEl = drawer.querySelector('[data-tasi-wishlist-empty]');
    var countEls = document.querySelectorAll('[data-tasi-wishlist-count]');
    var isOpen = false;
    var productCache = {};

    function formatWishlistMoney(cents) {
      return formatMoney(cents, moneyFormat);
    }

    function updateCount(count) {
      countEls.forEach(function (el) {
        if (count > 0) {
          el.textContent = count;
          el.hidden = false;
        } else {
          el.textContent = '0';
          el.hidden = true;
        }
      });
    }

    function escapeHtml(text) {
      var div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    function getProduct(handle) {
      if (productCache[handle]) return Promise.resolve(productCache[handle]);
      return fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (response) {
          if (!response.ok) throw new Error('Product not found');
          return response.json();
        })
        .then(function (product) {
          productCache[handle] = product;
          return product;
        });
    }

    function renderItem(item, product) {
      var variant = product.variants.find(function (entry) {
        return String(entry.id) === String(item.variantId);
      }) || product.variants[0];

      var image = variant.featured_image || product.featured_image;
      var imageHtml = image
        ? '<img src="' + image.src + '" alt="' + escapeHtml(product.title) + '" loading="lazy">'
        : '';
      var price = variant ? formatWishlistMoney(variant.price) : '';
      var sizeLabel = variant && variant.title !== 'Default Title' ? variant.title : '';

      return (
        '<article class="tasi-wishlist-drawer__item" data-wishlist-item="' + escapeHtml(item.handle) + '">' +
          '<a href="' + product.url + '" class="tasi-wishlist-drawer__item-image">' + imageHtml + '</a>' +
          '<div class="tasi-wishlist-drawer__item-details">' +
            '<div class="tasi-wishlist-drawer__item-head">' +
              '<a href="' + product.url + '" class="tasi-wishlist-drawer__item-title">' + escapeHtml(product.title) + '</a>' +
              '<button type="button" class="tasi-wishlist-drawer__remove" data-wishlist-remove="' + escapeHtml(item.handle) + '" aria-label="Remove from wishlist">Remove</button>' +
            '</div>' +
            (sizeLabel ? '<p class="tasi-wishlist-drawer__item-meta">' + escapeHtml(sizeLabel) + '</p>' : '') +
            '<p class="tasi-wishlist-drawer__item-price">' + price + '</p>' +
          '</div>' +
        '</article>'
      );
    }

    function renderDrawer() {
      var items = readWishlist();
      updateCount(items.length);

      if (!items.length) {
        if (itemsEl) itemsEl.innerHTML = '';
        if (emptyEl) emptyEl.hidden = false;
        return Promise.resolve();
      }

      if (emptyEl) emptyEl.hidden = true;

      return Promise.all(items.map(function (item) {
        return getProduct(item.handle).then(function (product) {
          return renderItem(item, product);
        }).catch(function () {
          return '';
        });
      })).then(function (rows) {
        if (itemsEl) itemsEl.innerHTML = rows.filter(Boolean).join('');
      });
    }

    function openDrawer() {
      if (isOpen) return;
      isOpen = true;
      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('wishlist-drawer-open');
      window.requestAnimationFrame(function () {
        drawer.classList.add('is-open');
      });
      renderDrawer();
    }

    function closeDrawer() {
      if (!isOpen) return;
      isOpen = false;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('wishlist-drawer-open');
      window.setTimeout(function () {
        if (!isOpen) drawer.hidden = true;
      }, 350);
    }

    function addItem(payload) {
      var items = readWishlist();
      var existingIndex = items.findIndex(function (item) {
        return item.handle === payload.handle;
      });
      var entry = {
        handle: payload.handle,
        variantId: String(payload.variantId),
        productId: String(payload.productId || ''),
        addedAt: Date.now()
      };

      if (existingIndex >= 0) {
        items[existingIndex] = entry;
      } else {
        items.unshift(entry);
      }

      writeWishlist(items);
      updateCount(items.length);
      return entry;
    }

    function removeItem(handle) {
      var items = readWishlist().filter(function (item) {
        return item.handle !== handle;
      });
      writeWishlist(items);
      updateCount(items.length);
      return renderDrawer();
    }

    function isSaved(handle) {
      return readWishlist().some(function (item) {
        return item.handle === handle;
      });
    }

    function syncPdpButtons() {
      document.querySelectorAll('[data-tasi-wishlist-add]').forEach(function (button) {
        var handle = button.dataset.productHandle;
        var saved = isSaved(handle);
        button.textContent = saved ? (button.dataset.labelSaved || 'Saved to Wishlist') : (button.dataset.labelAdd || 'Add to Wishlist');
        button.classList.toggle('is-saved', saved);
        button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      });
    }

    document.querySelectorAll('[data-tasi-wishlist-toggle]').forEach(function (button) {
      if (button.closest('[data-tasi-wishlist-drawer]')) return;
      button.addEventListener('click', function (event) {
        event.preventDefault();
        openDrawer();
      });
    });

    drawer.querySelectorAll('[data-tasi-wishlist-close]').forEach(function (button) {
      button.addEventListener('click', closeDrawer);
    });

    drawer.addEventListener('click', function (event) {
      var removeBtn = event.target.closest('[data-wishlist-remove]');
      if (!removeBtn) return;
      removeItem(removeBtn.getAttribute('data-wishlist-remove')).then(syncPdpButtons);
    });

    document.addEventListener('click', function (event) {
      var addBtn = event.target.closest('[data-tasi-wishlist-add]');
      if (!addBtn) return;
      event.preventDefault();

      var handle = addBtn.dataset.productHandle;
      var productId = addBtn.dataset.productId;
      var pdp = addBtn.closest('[data-tasi-pdp]');
      var variantSelect = pdp ? pdp.querySelector('[data-pdp-variant-select]') : null;
      var variantId = variantSelect ? variantSelect.value : null;

      if (!handle || !variantId) return;

      if (isSaved(handle)) {
        removeItem(handle).then(function () {
          syncPdpButtons();
        });
        return;
      }

      addItem({ handle: handle, variantId: variantId, productId: productId });
      syncPdpButtons();
      renderDrawer();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isOpen) closeDrawer();
    });

    document.addEventListener('tasi:wishlist-updated', function () {
      syncPdpButtons();
    });

    updateCount(readWishlist().length);
    syncPdpButtons();

    window.TasiWishlist = {
      open: openDrawer,
      close: closeDrawer,
      refresh: renderDrawer,
      add: addItem,
      remove: removeItem,
      isSaved: isSaved,
      syncPdpButtons: syncPdpButtons
    };
  }

  initWishlist();

  function initPdp(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-tasi-pdp]').forEach(function (pdp) {
      if (pdp.dataset.pdpReady === 'true') return;
      pdp.dataset.pdpReady = 'true';

      var jsonEl = pdp.querySelector('[data-pdp-product-json]');
      if (!jsonEl) return;

      var product = parseShopifyJson(jsonEl.textContent);
      if (!product) return;
      var moneyFormat = pdp.dataset.moneyFormat || '${{amount}}';
      var form = pdp.querySelector('[data-pdp-form]');
      var variantSelect = pdp.querySelector('[data-pdp-variant-select]');
      var priceEl = pdp.querySelector('[data-pdp-price-current]');
      var submitLabel = pdp.querySelector('[data-pdp-submit-label]');
      var submitBtn = pdp.querySelector('[data-pdp-submit]');
      var sizeConfirm = pdp.querySelector('[data-pdp-size-confirm]');
      var sizeLabel = pdp.querySelector('[data-pdp-selected-size-label]');
      var colorName = pdp.querySelector('[data-pdp-color-name]');
      var hasOptions = !product.has_only_default_variant;

      function getSelectedOptions() {
        var options = {};
        pdp.querySelectorAll('[data-pdp-option]').forEach(function (group) {
          var selected = group.querySelector('.is-selected');
          if (selected) options[group.dataset.pdpOption] = selected.dataset.optionValue;
        });
        return options;
      }

      function findVariant(options) {
        return product.variants.find(function (variant) {
          var match1 = !options['1'] || variant.option1 === options['1'];
          var match2 = !options['2'] || variant.option2 === options['2'];
          var match3 = !options['3'] || variant.option3 === options['3'];
          return match1 && match2 && match3;
        });
      }

      function allOptionsSelected() {
        var groups = pdp.querySelectorAll('[data-pdp-option]');
        if (!groups.length) return true;
        for (var i = 0; i < groups.length; i++) {
          if (!groups[i].querySelector('.is-selected')) return false;
        }
        return true;
      }

      function getVariantSelectValue(variant) {
        if (!variantSelect || !variant) return null;
        var optionLabel = [variant.option1, variant.option2, variant.option3].filter(Boolean).join(' / ');
        var matched = Array.prototype.find.call(variantSelect.options, function (optionEl) {
          return optionEl.dataset.options === optionLabel;
        });
        return matched ? matched.value : null;
      }

      function updateVariantUI(variant) {
        if (!variant) return;
        var selectValue = getVariantSelectValue(variant);
        if (variantSelect && selectValue) variantSelect.value = selectValue;
        if (priceEl) priceEl.textContent = formatMoney(variant.price, moneyFormat);

        if (submitBtn && submitLabel) {
          if (!hasOptions) {
            submitLabel.textContent = variant.available ? pdp.dataset.addLabel : pdp.dataset.soldOutLabel;
            submitBtn.disabled = !variant.available;
          } else if (!allOptionsSelected()) {
            submitLabel.textContent = pdp.dataset.selectSizeLabel;
            submitBtn.disabled = true;
          } else if (variant.available) {
            submitLabel.textContent = pdp.dataset.addLabel;
            submitBtn.disabled = false;
          } else {
            submitLabel.textContent = pdp.dataset.soldOutLabel;
            submitBtn.disabled = true;
          }
        }

        if (variant.featured_media && variant.featured_media.id) {
          var targetId = variant.featured_media.id;
          var slides = pdp.querySelectorAll('[data-pdp-gallery-slide]');
          var dots = pdp.querySelectorAll('[data-pdp-gallery-dot]');
          slides.forEach(function (slide, index) {
            var active = String(slide.dataset.mediaId) === String(targetId);
            slide.classList.toggle('is-active', active);
            if (dots[index]) dots[index].classList.toggle('is-active', active);
          });
          if (typeof pdp.__pdpGalleryIndex === 'number') {
            slides.forEach(function (slide, index) {
              if (slide.classList.contains('is-active')) pdp.__pdpGalleryIndex = index;
            });
          }
        }
      }

      function refreshFromSelection() {
        var options = getSelectedOptions();
        var variant = findVariant(options) || product.variants[0];
        var sizeSelected = pdp.querySelector('[data-pdp-option] .tasi-pdp__size.is-selected');

        if (sizeConfirm && sizeLabel) {
          if (sizeSelected) {
            sizeConfirm.hidden = false;
            sizeLabel.textContent = sizeSelected.dataset.optionValue;
          } else {
            sizeConfirm.hidden = true;
          }
        }

        updateVariantUI(variant);
        if (window.TasiWishlist && window.TasiWishlist.isSaved(product.handle) && variantSelect && variantSelect.value) {
          window.TasiWishlist.add({
            handle: product.handle,
            variantId: variantSelect.value,
            productId: pdp.dataset.productId || ''
          });
        }
      }

      pdp.querySelectorAll('[data-pdp-option] button[data-option-value]').forEach(function (button) {
        button.addEventListener('click', function () {
          if (button.classList.contains('is-sold-out')) return;
          var group = button.closest('[data-pdp-option]');
          group.querySelectorAll('.is-selected').forEach(function (el) { el.classList.remove('is-selected'); });
          button.classList.add('is-selected');
          if (colorName && button.classList.contains('tasi-pdp__swatch')) {
            colorName.textContent = button.dataset.optionValue;
          }
          refreshFromSelection();
        });
      });

      if (variantSelect) {
        variantSelect.addEventListener('change', function () {
          var variant = product.variants.find(function (item) {
            return String(item.id) === String(variantSelect.value);
          });
          updateVariantUI(variant);
        });
      }

      var slides = pdp.querySelectorAll('[data-pdp-gallery-slide]');
      var dots = pdp.querySelectorAll('[data-pdp-gallery-dot]');
      var prevBtn = pdp.querySelector('[data-pdp-gallery-prev]');
      var nextBtn = pdp.querySelector('[data-pdp-gallery-next]');

      function setGalleryIndex(index) {
        if (!slides.length) return;
        pdp.__pdpGalleryIndex = (index + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === pdp.__pdpGalleryIndex);
        });
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === pdp.__pdpGalleryIndex);
        });
        if (prevBtn) prevBtn.disabled = slides.length <= 1;
        if (nextBtn) nextBtn.disabled = slides.length <= 1;
      }

      if (slides.length) {
        pdp.__pdpGalleryIndex = 0;
        slides.forEach(function (slide, i) {
          if (slide.classList.contains('is-active')) pdp.__pdpGalleryIndex = i;
        });
        setGalleryIndex(pdp.__pdpGalleryIndex);
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          setGalleryIndex(pdp.__pdpGalleryIndex - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          setGalleryIndex(pdp.__pdpGalleryIndex + 1);
        });
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          setGalleryIndex(parseInt(dot.dataset.pdpGalleryDot, 10) || 0);
        });
      });

      refreshFromSelection();
      if (window.TasiWishlist) window.TasiWishlist.syncPdpButtons();
    });
  }

  function initProductRecommendations(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-tasi-product-recommendations]').forEach(function (section) {
      if (section.dataset.recommendationsReady === 'true') return;
      if (!section.dataset.url || section.innerHTML.trim()) {
        section.dataset.recommendationsReady = 'true';
        return;
      }

      var load = function () {
        if (section.dataset.recommendationsReady === 'true') return;
        section.dataset.recommendationsReady = 'true';
        fetch(section.dataset.url)
          .then(function (response) { return response.text(); })
          .then(function (text) {
            var html = document.createElement('div');
            html.innerHTML = text;
            var content = html.querySelector('[data-tasi-product-recommendations]');
            if (content && content.innerHTML.trim()) {
              section.innerHTML = content.innerHTML;
            } else {
              section.remove();
            }
          })
          .catch(function () {
            section.remove();
          });
      };

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              load();
              observer.disconnect();
            }
          });
        }, { rootMargin: '200px' });
        observer.observe(section);
      } else {
        load();
      }
    });
  }

  function initSizeGuideModal(root) {
    var scope = root || document;
    var modal = scope.querySelector('[data-size-guide-modal]');
    if (!modal || modal.dataset.sizeGuideReady === 'true') return;
    modal.dataset.sizeGuideReady = 'true';

    var openers = scope.querySelectorAll('[data-size-guide-open]');
    var closers = modal.querySelectorAll('[data-size-guide-close]');
    var lastFocus = null;

    function openModal() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var closeBtn = modal.querySelector('.tasi-size-guide-modal__close');
      if (closeBtn) closeBtn.focus();
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.hidden = true;
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    openers.forEach(function (button) {
      button.addEventListener('click', openModal);
    });

    closers.forEach(function (button) {
      button.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });
  }

  function applyCustomCollectionFilters(collectionEl) {
    if (!collectionEl) return;

    var params = new URLSearchParams(window.location.search);
    var customCategories = params.getAll('filter.custom.category');
    var customColors = params.getAll('filter.custom.color');
    var cards = collectionEl.querySelectorAll('[data-tasi-collection-card]');
    var visibleCount = 0;

    if (!customCategories.length && !customColors.length) {
      cards.forEach(function (card) {
        card.hidden = false;
      });
      return;
    }

    cards.forEach(function (card) {
      var title = (card.dataset.productTitle || '').toLowerCase();
      var tags = (card.dataset.productTags || '').toLowerCase().split('|').filter(Boolean);
      var type = (card.dataset.productType || '').toLowerCase();
      var categoryMatch = !customCategories.length || customCategories.some(function (category) {
        var value = category.toLowerCase();
        if (tags.indexOf(value) !== -1) return true;
        if (type && type === value) return true;
        if (value === 'dresses' && title.indexOf('dress') !== -1) return true;
        if (value === 'outerwear' && (title.indexOf('blazer') !== -1 || title.indexOf('jacket') !== -1)) return true;
        if (value === 'tops' && (title.indexOf('blouse') !== -1 || title.indexOf(' top') !== -1 || title.indexOf('shirt') !== -1)) return true;
        if (value === 'pants' && (title.indexOf('pant') !== -1 || title.indexOf('trouser') !== -1)) return true;
        if (value === 'skirts' && title.indexOf('skirt') !== -1) return true;
        if (value === 'jumpsuits' && title.indexOf('jumpsuit') !== -1) return true;
        if (value === 'cheongsam' && (title.indexOf('qipao') !== -1 || title.indexOf('cheongsam') !== -1)) return true;
        return title.indexOf(value) !== -1;
      });
      var colorMatch = !customColors.length || customColors.some(function (color) {
        return title.indexOf(color.toLowerCase()) !== -1;
      });
      var visible = categoryMatch && colorMatch;
      card.hidden = !visible;
      if (visible) visibleCount += 1;
    });

    var emptyEl = collectionEl.querySelector('[data-collection-empty]');
    var gridEl = collectionEl.querySelector('[data-collection-grid]');
    if (emptyEl) emptyEl.hidden = visibleCount > 0;
    if (gridEl) gridEl.hidden = visibleCount === 0;
  }

  initPdp();
  initSizeGuideModal();
  initProductRecommendations();
  initCollection();

  function initCollection(root) {
    var scope = root || document;
    var collectionEl = scope.querySelector('[data-tasi-collection]');
    if (!collectionEl || collectionEl.dataset.collectionReady === 'true') return;
    collectionEl.dataset.collectionReady = 'true';

    var filterDrawer = collectionEl.querySelector('[data-collection-filter-drawer]');
    var filterOpen = collectionEl.querySelector('[data-collection-filter-open]');
    var filterCloseEls = collectionEl.querySelectorAll('[data-collection-filter-close]');
    var sortSelect = collectionEl.querySelector('[data-collection-sort]');
    var filterForm = collectionEl.querySelector('[data-collection-filters]');

    function openFilters() {
      if (!filterDrawer) return;
      filterDrawer.hidden = false;
      document.body.classList.add('collection-filter-open');
      if (filterOpen) filterOpen.setAttribute('aria-expanded', 'true');
    }

    function closeFilters() {
      if (!filterDrawer) return;
      filterDrawer.hidden = true;
      document.body.classList.remove('collection-filter-open');
      if (filterOpen) filterOpen.setAttribute('aria-expanded', 'false');
    }

    if (filterOpen) filterOpen.addEventListener('click', openFilters);
    filterCloseEls.forEach(function (el) {
      el.addEventListener('click', closeFilters);
    });

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        window.location.href = url.toString();
      });
    }

    if (filterForm) {
      filterForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var params = new URLSearchParams(new FormData(filterForm));
        if (sortSelect && sortSelect.value) {
          params.set('sort_by', sortSelect.value);
        }
        window.location.href = window.location.pathname + '?' + params.toString();
      });
    }

    applyCustomCollectionFilters(collectionEl);

    scope.querySelectorAll('[data-tasi-collection-card]').forEach(function (card) {
      if (card.dataset.cardReady === 'true') return;
      card.dataset.cardReady = 'true';

      var quick = card.querySelector('[data-card-quick]');
      var addBtn = card.querySelector('[data-card-add]');
      var msgEl = card.querySelector('[data-card-msg]');
      var selectedVariantId = addBtn ? addBtn.dataset.defaultVariantId || null : null;

      function showQuick() {
        if (quick) quick.hidden = false;
      }

      function hideQuick() {
        if (quick) quick.hidden = true;
      }

      if (quick) {
        card.addEventListener('mouseenter', showQuick);
        card.addEventListener('mouseleave', hideQuick);
        card.addEventListener('focusin', showQuick);
        card.addEventListener('focusout', function (event) {
          if (!card.contains(event.relatedTarget)) hideQuick();
        });
      }

      card.querySelectorAll('[data-size-value]').forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (button.disabled || !button.dataset.variantId) return;
          card.querySelectorAll('[data-size-value].is-selected').forEach(function (el) {
            el.classList.remove('is-selected');
          });
          button.classList.add('is-selected');
          selectedVariantId = button.dataset.variantId;
          if (addBtn) addBtn.disabled = false;
        });
      });

      if (addBtn) {
        addBtn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (!selectedVariantId) return;

          addBtn.disabled = true;
          if (msgEl) msgEl.hidden = true;

          addItemToCart(selectedVariantId, 1)
            .then(function () {
              if (msgEl) {
                msgEl.hidden = false;
                msgEl.textContent = 'Added to bag';
              }
              addBtn.disabled = false;
              if (window.TasiCart) {
                window.TasiCart.refresh().then(function () {
                  window.TasiCart.open();
                });
              }
            })
            .catch(function () {
              if (msgEl) {
                msgEl.hidden = false;
                msgEl.textContent = 'Could not add to bag';
              }
              addBtn.disabled = !selectedVariantId;
            });
        });
      }
    });
  }

  function initCollectionSliders(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-tasi-collection-slider]').forEach(function (slider) {
      if (slider.dataset.collectionReady === 'true') return;

      var viewport = slider.querySelector('[data-collection-viewport]');
      var track = slider.querySelector('[data-collection-track]');
      var prevBtn = slider.querySelector('[data-collection-prev]');
      var nextBtn = slider.querySelector('[data-collection-next]');
      var progressThumb = slider.querySelector('[data-collection-progress]');
      if (!viewport || !track) return;

      slider.dataset.collectionReady = 'true';

      var dragState = {
        active: false,
        startX: 0,
        startY: 0,
        startScroll: 0,
        moved: false,
        pointerId: null
      };

      var DRAG_THRESHOLD = 10;

      function getSlidesPerView() {
        if (window.innerWidth <= 767) {
          return parseInt(slider.dataset.slidesMobile, 10) || 1;
        }
        if (window.innerWidth <= 980) {
          return parseInt(slider.dataset.slidesTablet, 10) || 2;
        }
        return parseInt(slider.dataset.slidesDesktop, 10) || 3;
      }

      function getGap() {
        var styles = window.getComputedStyle(track);
        return parseFloat(styles.columnGap || styles.gap || '0') || 0;
      }

      function getSlideStep() {
        var slide = track.querySelector('.tasi-collection-slider__slide');
        if (!slide) return viewport.clientWidth;
        return slide.offsetWidth + getGap();
      }

      function updateProgress() {
        if (!progressThumb) return;
        var maxScroll = Math.max(viewport.scrollWidth - viewport.clientWidth, 0);
        var thumbWidth = viewport.scrollWidth > 0
          ? (viewport.clientWidth / viewport.scrollWidth) * 100
          : 100;
        var left = maxScroll > 0
          ? (viewport.scrollLeft / maxScroll) * (100 - thumbWidth)
          : 0;
        progressThumb.style.width = thumbWidth + '%';
        progressThumb.style.left = left + '%';
      }

      function updateMetrics() {
        var slides = getSlidesPerView();
        var gap = getGap();
        slider.style.setProperty('--collection-slides', slides);
        var slideWidth = (viewport.clientWidth - gap * (slides - 1)) / slides;
        slider.style.setProperty('--collection-slide-width', Math.max(slideWidth, 0) + 'px');
        updateArrows();
        updateProgress();
      }

      function updateArrows() {
        if (!prevBtn && !nextBtn) return;
        var maxScroll = Math.max(viewport.scrollWidth - viewport.clientWidth, 0);
        var atStart = viewport.scrollLeft <= 1;
        var atEnd = viewport.scrollLeft >= maxScroll - 1;
        if (prevBtn) prevBtn.disabled = atStart;
        if (nextBtn) nextBtn.disabled = atEnd;
      }

      function scrollByStep(direction) {
        viewport.scrollBy({ left: direction * getSlideStep(), behavior: 'smooth' });
      }

      function onPointerDown(event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        dragState.active = true;
        dragState.startX = event.clientX;
        dragState.startY = event.clientY;
        dragState.startScroll = viewport.scrollLeft;
        dragState.moved = false;
        dragState.pointerId = event.pointerId;
      }

      function onPointerMove(event) {
        if (!dragState.active) return;
        var deltaX = event.clientX - dragState.startX;
        var deltaY = event.clientY - dragState.startY;

        if (!dragState.moved) {
          if (Math.abs(deltaX) < DRAG_THRESHOLD && Math.abs(deltaY) < DRAG_THRESHOLD) return;
          dragState.moved = true;
          viewport.classList.add('is-dragging');
          if (viewport.setPointerCapture) {
            viewport.setPointerCapture(dragState.pointerId);
          }
        }

        event.preventDefault();
        viewport.scrollLeft = dragState.startScroll - deltaX;
        updateArrows();
        updateProgress();
      }

      function blockNextClick() {
        var blockClick = function (clickEvent) {
          clickEvent.preventDefault();
          clickEvent.stopImmediatePropagation();
        };
        track.querySelectorAll('a').forEach(function (link) {
          link.addEventListener('click', blockClick, { capture: true, once: true });
        });
      }

      function onPointerEnd(event) {
        if (!dragState.active) return;
        var didDrag = dragState.moved;
        dragState.active = false;
        dragState.moved = false;
        dragState.pointerId = null;
        viewport.classList.remove('is-dragging');
        if (viewport.releasePointerCapture && event.pointerId != null) {
          try { viewport.releasePointerCapture(event.pointerId); } catch (e) {}
        }
        if (didDrag) blockNextClick();
        updateArrows();
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          scrollByStep(-1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          scrollByStep(1);
        });
      }

      viewport.addEventListener('pointerdown', onPointerDown);
      viewport.addEventListener('pointermove', onPointerMove, { passive: false });
      viewport.addEventListener('pointerup', onPointerEnd);
      viewport.addEventListener('pointercancel', onPointerEnd);
      viewport.addEventListener('scroll', function () {
        updateArrows();
        updateProgress();
      }, { passive: true });

      track.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('dragstart', function (event) {
          event.preventDefault();
        });
      });

      window.addEventListener('resize', updateMetrics, { passive: true });
      updateMetrics();
      window.requestAnimationFrame(updateMetrics);
    });
  }

  initCollectionSliders();

  function initBlogCarousels(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-tasi-blog-carousel]').forEach(function (carousel) {
      if (carousel.dataset.blogReady === 'true') return;

      var viewport = carousel.querySelector('[data-blog-viewport]');
      var track = carousel.querySelector('[data-blog-track]');
      var prevBtn = carousel.querySelector('[data-blog-prev]');
      var nextBtn = carousel.querySelector('[data-blog-next]');
      var progressThumb = carousel.querySelector('[data-blog-progress]');
      if (!viewport || !track) return;

      carousel.dataset.blogReady = 'true';

      var autoplayEnabled = carousel.dataset.autoplay === 'true';
      var autoplaySpeed = (parseInt(carousel.dataset.autoplaySpeed, 10) || 5) * 1000;
      var autoplayTimer = null;
      var isPaused = false;

      var dragState = {
        active: false,
        startX: 0,
        startY: 0,
        startScroll: 0,
        moved: false,
        pointerId: null
      };

      var DRAG_THRESHOLD = 10;

      function getSlidesPerView() {
        if (window.innerWidth <= 767) {
          return parseInt(carousel.dataset.slidesMobile, 10) || 1;
        }
        if (window.innerWidth <= 980) {
          return parseInt(carousel.dataset.slidesTablet, 10) || 3;
        }
        return parseInt(carousel.dataset.slidesDesktop, 10) || 5;
      }

      function getGap() {
        var styles = window.getComputedStyle(track);
        return parseFloat(styles.columnGap || styles.gap || '0') || 0;
      }

      function getSlideStep() {
        var slide = track.querySelector('.tasi-blog-card');
        if (!slide) return viewport.clientWidth;
        return slide.offsetWidth + getGap();
      }

      function updateProgress() {
        if (!progressThumb) return;
        var maxScroll = Math.max(viewport.scrollWidth - viewport.clientWidth, 0);
        var thumbWidth = viewport.scrollWidth > 0
          ? (viewport.clientWidth / viewport.scrollWidth) * 100
          : 100;
        var left = maxScroll > 0
          ? (viewport.scrollLeft / maxScroll) * (100 - thumbWidth)
          : 0;
        progressThumb.style.width = thumbWidth + '%';
        progressThumb.style.left = left + '%';
      }

      function updateArrows() {
        if (!prevBtn && !nextBtn) return;
        var maxScroll = Math.max(viewport.scrollWidth - viewport.clientWidth, 0);
        var atStart = viewport.scrollLeft <= 1;
        var atEnd = viewport.scrollLeft >= maxScroll - 1;
        if (prevBtn) prevBtn.disabled = atStart;
        if (nextBtn) nextBtn.disabled = atEnd;
      }

      function updateMetrics() {
        var slides = getSlidesPerView();
        var gap = getGap();
        carousel.style.setProperty('--blog-slides', slides);
        var slideWidth = (viewport.clientWidth - gap * (slides - 1)) / slides;
        carousel.style.setProperty('--blog-slide-width', Math.max(slideWidth, 0) + 'px');
        updateArrows();
        updateProgress();
      }

      function scrollByStep(direction) {
        var maxScroll = Math.max(viewport.scrollWidth - viewport.clientWidth, 0);
        var step = getSlideStep();
        var target = viewport.scrollLeft + direction * step;

        if (direction > 0 && target >= maxScroll - 1) {
          viewport.scrollTo({ left: 0, behavior: 'smooth' });
          return;
        }

        if (direction < 0 && viewport.scrollLeft <= 1) {
          viewport.scrollTo({ left: maxScroll, behavior: 'smooth' });
          return;
        }

        viewport.scrollBy({ left: direction * step, behavior: 'smooth' });
      }

      function stopAutoplay() {
        if (autoplayTimer) {
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      }

      function startAutoplay() {
        stopAutoplay();
        if (!autoplayEnabled || isPaused) return;
        var maxScroll = Math.max(viewport.scrollWidth - viewport.clientWidth, 0);
        if (maxScroll <= 0) return;

        autoplayTimer = setInterval(function () {
          if (dragState.active || isPaused) return;
          scrollByStep(1);
        }, autoplaySpeed);
      }

      function onPointerDown(event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        dragState.active = true;
        dragState.startX = event.clientX;
        dragState.startY = event.clientY;
        dragState.startScroll = viewport.scrollLeft;
        dragState.moved = false;
        dragState.pointerId = event.pointerId;
        stopAutoplay();
      }

      function onPointerMove(event) {
        if (!dragState.active) return;
        var deltaX = event.clientX - dragState.startX;
        var deltaY = event.clientY - dragState.startY;

        if (!dragState.moved) {
          if (Math.abs(deltaX) < DRAG_THRESHOLD && Math.abs(deltaY) < DRAG_THRESHOLD) return;
          dragState.moved = true;
          viewport.classList.add('is-dragging');
          if (viewport.setPointerCapture) {
            viewport.setPointerCapture(dragState.pointerId);
          }
        }

        event.preventDefault();
        viewport.scrollLeft = dragState.startScroll - deltaX;
        updateArrows();
        updateProgress();
      }

      function blockNextClick() {
        var blockClick = function (clickEvent) {
          clickEvent.preventDefault();
          clickEvent.stopImmediatePropagation();
        };
        track.querySelectorAll('a').forEach(function (link) {
          link.addEventListener('click', blockClick, { capture: true, once: true });
        });
      }

      function onPointerEnd(event) {
        if (!dragState.active) return;
        var didDrag = dragState.moved;
        dragState.active = false;
        dragState.moved = false;
        dragState.pointerId = null;
        viewport.classList.remove('is-dragging');
        if (viewport.releasePointerCapture && event.pointerId != null) {
          try { viewport.releasePointerCapture(event.pointerId); } catch (e) {}
        }
        if (didDrag) blockNextClick();
        updateArrows();
        startAutoplay();
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          scrollByStep(-1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          scrollByStep(1);
        });
      }

      carousel.addEventListener('mouseenter', function () {
        isPaused = true;
        stopAutoplay();
      });

      carousel.addEventListener('mouseleave', function () {
        isPaused = false;
        startAutoplay();
      });

      carousel.addEventListener('focusin', stopAutoplay);
      carousel.addEventListener('focusout', startAutoplay);

      viewport.addEventListener('pointerdown', onPointerDown);
      viewport.addEventListener('pointermove', onPointerMove, { passive: false });
      viewport.addEventListener('pointerup', onPointerEnd);
      viewport.addEventListener('pointercancel', onPointerEnd);
      viewport.addEventListener('scroll', function () {
        updateArrows();
        updateProgress();
      }, { passive: true });

      track.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('dragstart', function (event) {
          event.preventDefault();
        });
      });

      window.addEventListener('resize', function () {
        updateMetrics();
        startAutoplay();
      }, { passive: true });

      updateMetrics();
      window.requestAnimationFrame(function () {
        updateMetrics();
        startAutoplay();
      });
    });
  }

  initBlogCarousels();

  document.addEventListener('shopify:section:load', function (event) {
    initProductCarousels(event.target);
    initCollectionSliders(event.target);
    initBlogCarousels(event.target);
    initPdp(event.target);
    initSizeGuideModal(event.target);
    initProductRecommendations(event.target);
    initCollection(event.target);
    applyCustomCollectionFilters(event.target.querySelector('[data-tasi-collection]'));
    if (window.TasiWishlist) window.TasiWishlist.syncPdpButtons();
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-tasi-product-carousel]').forEach(function (carousel) {
      delete carousel.dataset.carouselReady;
    });
    event.target.querySelectorAll('[data-tasi-collection-slider]').forEach(function (slider) {
      delete slider.dataset.collectionReady;
    });
    event.target.querySelectorAll('[data-tasi-blog-carousel]').forEach(function (carousel) {
      delete carousel.dataset.blogReady;
    });
    event.target.querySelectorAll('[data-tasi-pdp]').forEach(function (pdp) {
      delete pdp.dataset.pdpReady;
    });
  });
})();
